import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = [ "dialog", "body" ]
  static values = {
    open: {
      type: Boolean,
      default: false,
    }
  }

  initialize() {
    this.forceClose = this.forceClose.bind(this)
  }
  connect() {
    if (this.openValue) {
      this.open()
    }
    document.addEventListener("turbo:before-render", this.forceClose)
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.forceClose)
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.setAttribute("closing", "")

    Promise.all(this.dialogTarget.getAnimations().map((animation) => animation.finished)).then(() => {
      this.dialogTarget.removeAttribute("closing")
      this.dialogTarget.close()
    })
  }

  bodyTargetConnected() {
    this.open()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Called on turbo:submit-end
  // event.details returns FormSubmission object
  submitEnd(event) {
    if(event.detail.success){
      this.close()
    }
  }

  forceClose() {
    this.dialogTarget.close()
  }
}
